import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PriorityRating } from '@capital-access/targeting/common';
import { CUSTOM_TARGET_API_BASE_URL } from '../constants';

@Injectable()
export class CustomTargetRepository {
  constructor(private http: HttpClient) {}

  saveCustomTargetRating(securityId: number, institutionId: number, rating: PriorityRating) {
    const url = `${CUSTOM_TARGET_API_BASE_URL}/securities/${securityId}/institutions/${institutionId}/customRating`;
    const params = new HttpParams().set('rating', rating.toString());
    return this.http.post(url, null, { params });
  }

  deleteCustomTargetRating(securityId: number, institutionIds: number[]) {
    const url = `${CUSTOM_TARGET_API_BASE_URL}/securities/${securityId}/customRatings`;
    let params = new HttpParams();
    for (const id of institutionIds) {
      params = params.append('institutionIds', id.toString());
    }
    return this.http.delete(url, { params });
  }
}
